import Language from "./Language";

export const BritishEnglish = new Language('en-GB', 'English (UK)');
export const StandardGerman = new Language('de-DE', 'Deutsch');



// WEBPACK FOOTER //
// ./src/modules/consumer/models/Languages.ts